'use client';

import { useTranslations } from 'next-intl';

import { ErrorPage } from '@/components/ui/ErrorPage';

export function LinkExpired() {
  const t = useTranslations();

  return (
    <ErrorPage
      title={t('get-feedback-linkExpired-title')}
      description={t('get-feedback-linkExpired-description')}
    />
  );
}
